import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { InjectConfig, PdfSharedConfigKey } from '@ddt-web/config-layer';
import { ClientOutput } from '@ddt-web/domain';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subscription } from 'rxjs';

@UntilDestroy()
@Component({
	selector: 'ac-pdf-report-details',
	templateUrl: './pdf-report-details.component.html',
	styleUrls: ['./pdf-report-details.component.scss']
})
export class PdfReportDetailsComponent implements AfterViewInit {


	@Input() public model: ClientOutput;
	@Input() public disableReportGeneration: boolean = false;
	@Input() public firmNameRequired: boolean = false;
	@ViewChild('reportForm', { read: NgForm }) public form: NgForm;
	@Output() public onFormChange: EventEmitter<NgForm> = new EventEmitter<NgForm>();

	@InjectConfig(PdfSharedConfigKey.SHOULD_SHOW_FIRM_NAME_INPUT) public readonly showFirmName: boolean = true;
	@InjectConfig(PdfSharedConfigKey.IS_REPORT_NAME_READONLY) public readonly isNameReadonly: boolean = false;
	@InjectConfig(PdfSharedConfigKey.IS_REPORT_FIRM_NAME_READONLY) public readonly isFirmNameReadonly: boolean = false;

	private subscription: Subscription;

	public ngAfterViewInit(): void {
		// To have the viewchild element reflect the updated object we need to wait
		// for the change detection job to run and update it. SetTimeout delays the
		// event by one lifecycle turn which gives the element the necessary time to
		// get updated and then be sent with the actual values.
		const firmNameRequired = this.firmNameRequired;
		if (this.form && !this.subscription) {
			setTimeout(() => this.onFormChange.emit(this.form));
			this.subscription = this.form.valueChanges.pipe(untilDestroyed(this))
				.subscribe(() => setTimeout(() => {
					this.firmNameRequired = firmNameRequired;
					this.onFormChange.emit(this.form);
				}));
		}
	}
}
